import type { TableCellProps as MuiTableCellProps } from '@mui/material';
import { TableCell as MuiTableCell } from '@mui/material';

/**
 * <p>
 * Based on MUI TableCell: https://mui.com/material-ui/api/table-cell/
 * </p>
 * */
export const TableCell = (props: MuiTableCellProps) => <MuiTableCell {...props} />;
